import { render, staticRenderFns } from "./SettingsTabGeneral.vue?vue&type=template&id=d9e8c582&"
import script from "./SettingsTabGeneral.vue?vue&type=script&lang=js&"
export * from "./SettingsTabGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports